import { HttpClient, HttpErrorResponse, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { catchError, from, map, Observable, switchMap, throwError } from "rxjs";
export enum LoginType {
  NORMAL = 'NORMAL',
  GOOGLE = 'GOOGLE',
  LINKEDIN = 'LINKEDIN',
  MICROSOFT = 'M365'
}

interface PresignedUrlResponse {
  data: {
    objectUrl: string;
    preSignedUrl: string;
  }
}

@Injectable({
    providedIn: 'root'
})
export class MainService {
    constructor(private http: HttpClient){}

    getSkills(skip: number = 0, limit: number = 10,serach:string=''){
      return this.http.get(`skills/secondary?skip=${skip}&limit=${limit}&project=label,alias,tksStatementId,workspaceId&search=${serach}`)
    }

    getUser(){
        return this.http.get('employees/portal/me').pipe(
          map((res: any) => {
            return res.data;
          })
        )
    }

    getTeamMembers() {
      return this.http.get(`employees/portal/reporting-to-me`).pipe(
        map((res: any) => {
          return res.data;
        })
      )
    }
  
    getEmployeeProfile(employeeId: string) {
      return this.http.get(`employees/portal/${employeeId}`).pipe(
        map((res: any) => {
          return res.data;
        })
      )
    }

    updateProfile(employeeId: string, profile: any){
        return this.http.patch(`employees/portal/${employeeId}`, profile).pipe(
            map((res: any) => {
                return res.data;
            })
        )
    }

    uploadFileToAWS(file: Blob | File | any): Observable<string> {
      const contentType = file.type;
      const key = `resume/${file?.name}`;
  
      return this.getPresignedUrl({ key, contentType }).pipe(
        switchMap((response: any) => {
          const { objectUrl, preSignedUrl } = response?.data;
          return this.uploadImageToAWS(preSignedUrl, contentType, file).pipe(
            map(() => objectUrl)
          );
        }),
        catchError(this.handleError)
      );
    }
  
    private getPresignedUrl(params: { key: string, contentType: string }): Observable<PresignedUrlResponse> {
      return this.http.get<PresignedUrlResponse>(
        `utils/pre-signed-url-employee?key=${params.key}&contentType=${params.contentType}`
      );
    }

    private uploadImageToAWS(preSignedUrl: string, contentType: string, file: Blob | File): Observable<void> {
      const headers = new HttpHeaders({
        'Content-Type': contentType,
        'Skip-API-Prefix': 'true'
      });
  
      return this.http.put<void>(preSignedUrl, file, { headers })
        .pipe(
          catchError(this.handleError)
        );
    }

    private handleError(error: HttpErrorResponse) {
      let errorMessage = 'An unknown error occurred!';
      if (error.error instanceof ErrorEvent) {
        errorMessage = `Client-side error: ${error.error.message}`;
      } else {
        errorMessage = `Server-side error: ${error.status} ${error.message}`;
      }
      console.error(errorMessage);
      return throwError(() => new Error(errorMessage));
    }
}